import Header from '@custom/Header/Header'
import { customStyle } from '@custom/Utils/utils'
import React, { useRef, useState } from 'react';
import { useTheme } from '../../ui/src/contextProviders'
import GraphForm from './GraphForm';
import TabularForm from './TabularForm';
import { downloadIconBlack } from '../../ui/assets/svgIcons/icon';

const Analytics = () => {
  const currentYear = new Date().getFullYear();
  const { isDarkMode } = useTheme();
  const [view, setView] = useState('graph');
  const [selectedYear, setSelectedYear] = useState<number>(currentYear)


  return (
    <div className='page page__full' style={
      isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
    }>
      <Header title={'Analytics'} isBack={false} />
      <div className='page__body'>
        <div className="details">
          <div className='w-100 border-red-300 flex justify-between items-center flex-wrap gap-2'>
            <h3 className='title title--h4'>Executive Summary</h3>
            <div className='flex flex-wrap gap-2'>
              <div>
                <select id="year-select" className="year-dropdown" style={customStyle.select} value={selectedYear}  onChange={(e) => setSelectedYear(Number(e.target.value))}>
                  {Array.from({ length: currentYear - 1945 + 1 }, (_, index) => 1945 + index).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form__radio form__radio--gray flex-wrap gap-2">
                <div className="form__radio__option m-0">
                  <input
                    type="radio"
                    className="form__radio__input"
                    value="graph"
                    checked={view == 'graph'}
                    onChange={() => setView('graph')}
                  />
                  <label className="form__radio__label">Graph</label>
                </div>
                <div className="form__radio__option m-0">
                  <input
                    type="radio"
                    className="form__radio__input"
                    value="tabular"
                    checked={view == 'tabular'}
                    onChange={() => setView('tabular')}
                  />
                  <label className="form__radio__label">Tabular</label>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6">
            {view === 'graph' ? (
              <GraphForm selectedYear={selectedYear} />
            ) : (
              <TabularForm selectedYear={selectedYear} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Analytics
